module.exports = __webpack_public_path__ + "static/front-cover-dff5b8bb3849bbce87503d1218095a30.jpg";